// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"sort_scroll-black__guoyn","label":"sort_label__LzxVm"};